<template>
  <div>
    <b-loading :active.sync="loading" />
    <div class="w-full flex justify-between items-center">
      <Lynx-Title text="Exportação de relatórios do" />
    </div>
    <div class="w-full flex mt-8 grid grid-cols-2 gap-8 items-start">
      <div v-for="(card, index) in cards" :key="index">
        <Card
          v-if="card.title !== 'Relatório Empresas Plano'"
          class="font-body cursor-pointer"
          :color="card.color"
          @click.native="card.action"
        >
          <div>
            <div class="p-6 flex items-start">
              <div class="flex flex-col ml-4">
                <p class="font-semibold pb-4 text-primary-800">{{ card.title }}</p>
                <p class="font-semibold text-primary-800">
                  <span class="text-neutral-800 font-normal text-neutral-700">
                    {{ card.description }}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </Card>
        <Card
          v-else
          class="font-body"
          :color="card.color"
        >
          <div>
            <div class="p-6 flex items-start">
              <div class="flex flex-col ml-4">
                <p class="font-semibold pb-4 text-primary-800">{{ card.title }}</p>
                <p class="font-semibold text-primary-800">
                  <span class="text-neutral-800 font-normal text-neutral-700">
                    {{ card.description }}
                  </span>
                </p>
              </div>
            </div>
            <div>
              <treeselect
                :multiple="true"
                :options="filteredPlans"
                placeholder="Selecione a carteira..."
                v-model="plano_id"
              />
              <div class="flex self-end ml-4">
                <Lynx-Button text="gerar" class="mt-2" @click.native="exportPlano()" />
              </div>
            </div>
          </div>
        </Card>
      </div>
    </div>

    <!-- Modals -->
    <b-modal :active.sync="comissao" v-b-modal.modal-lg can-cancel>
      <div class="modal-body bg-neutral-300 shadow p-10" style="height: 620px">
        <Lynx-Title text="Exportar" />
        <h2 class="pb-8 text-xl font-display text-primary-600">
          Relatório de Comissõe Dos Vendedores
        </h2>
        <div class="flex flex-wrap">
          <div class="w-full flex">
            <label class="flex flex-col w-1/3 pr-4">
              <Lynx-Label label="Competencia" />
              <b-datepicker placeholder="Informe uma data de competencia" icon="calendar-today" type="month"
                :month-names="monthNames" :day-names="dayNames" v-model="form.data_competencia" />
            </label>
            <label class="flex flex-col w-1/2 pb-6 pr-3">
              <Lynx-Label label="Usuarios" />
              <treeselect :multiple="false" :options="lista_usuarios" placeholder="Selecione os usuarios..."
                v-model="usuario" />
            </label>
          </div>
          <Lynx-Button text="gerar" class="mr-2" @click.native="comissaoRelatorio()" />
        </div>
      </div>
    </b-modal>

    <b-modal :active.sync="deondevem" v-b-modal.modal-lg can-cancel>
      <div class="modal-body bg-neutral-300 shadow p-10" style="height: 520px">
        <Lynx-Title text="Exportar" />
        <h2 class="pb-8 text-xl font-display text-primary-600">
          Relatório Financeiro Valores de cada Tipo Cobrança
        </h2>
        <div class="flex flex-wrap">
          <div class="w-full flex">
            <label class="flex flex-col w-1/3 pr-4">
              <Lynx-Label label="Competencia" />
              <b-datepicker placeholder="Informe uma data de competencia" icon="calendar-today" type="month"
                :month-names="monthNames" :day-names="dayNames" v-model="form.data_competencia" />
            </label>
          </div>
          <Lynx-Button text="gerar" class="mr-2 mt-3" @click.native="deondevemRelatorio()" />
        </div>
      </div>
    </b-modal>

    <b-modal :active.sync="baixadosmodel" v-b-modal.modal-lg can-cancel>
      <div class="modal-body bg-neutral-300 shadow p-10" style="height: 520px">
        <Lynx-Title text="Exportar" />
        <h2 class="pb-8 text-xl font-display text-primary-600">
          Relatório Baixados
        </h2>
        <div class="flex flex-wrap">
          <div class="w-full flex">
            <label class="flex flex-col w-1/2 pr-3 pb-6">
              <Lynx-Label label="Data de Início" />
              <b-datepicker size="sm" v-model="form.data_inicial" placeholder="Selecione uma data"
                :date-formatter="(date) => moment(date, 'YYYY/MM/DD').format('DD/MM/YYYY')"
                :date-parser="(date) => new Date(date)" :month-names="monthNames" :day-names="dayNames"
                :years-range="[-20, 10]" />
            </label>
            <label class="flex flex-col w-1/2 pl-3 pb-6">
              <Lynx-Label label="Data de final" />
              <b-datepicker calendar-width="100%" menu-class="w-100" v-model="form.data_final"
                placeholder="Selecione uma data"
                :date-formatter="(date) => moment(date, 'YYYY/MM/DD').format('DD/MM/YYYY')"
                :date-parser="(date) => new Date(date)" :month-names="monthNames" :day-names="dayNames"
                :years-range="[-20, 10]" />
            </label>
          </div>
          <Lynx-Button text="gerar" class="mr-2 mt-3" @click.native="canceladosRelatorio()" />
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Card from "@/components/helpers/Card";
import moment from "moment";
import { monthNames, dayNames } from "@/utils/utils";
import Treeselect from "@riophae/vue-treeselect";
import { usersRequest } from "@/services/requests/users";
import { formatBrToEn } from "../../utils/momentHelpers";
import { plansRequest } from "../../services/requests/plans";

export default {
  components: { Card, Treeselect },
  name: "index",
  data() {
    return {
      lista_usuarios: null,
      monthNames,
      dayNames,
      moment,
      deondevem: false,
      baixadosmodel: false,
      plano_id: null,
      comissao: false,
      loading: false,
      usuario: null,
      form: {
        data_competencia: new Date(),
        usuario: {},
      },
      plansArray: [],
      cards: [
        {
          title: "Congeladas",
          description:
            "• Relatório de Congelamento com Empresa; Cliente; Valor e DATA de Congelamento",
          color: "primary-500",
          action: () => this.congelados(),
        },
        {
          title: "Baixados",
          description:
            "• Relatório de Cancelamentos com Empresa; Cliente; Motivo e Encerramento",
          color: "primary-500",
          action: () => (this.baixadosmodel = true),
        },
        {
          title: "Empresas Sem Alvara",
          description: "• Relatório de Empresas sem Alvara",
          color: "primary-500",
          action: () => this.semAlvara(),
        },
        {
          title: "Empresas Sem Contrato",
          description: "• Relatório de Empresas sem Contrato",
          color: "primary-500",
          action: () => this.semContrato(),
        },
        {
          title: "Empresas X Fatura",
          description: "• Relatório de Empresas x Fatura",
          color: "primary-500",
          action: () => this.ClienteXFatura(),
        },
        {
          title: "Empresas X Fatura Pagos no cartao",
          description: "• Relatório de Empresas x Fatura Pagos no Cartão",
          color: "primary-500",
          action: () => this.ClienteXFaturaCartao(),
        },
        {
          title: "Empresas Previsoes",
          description:
            "• Relatório de Empresas Previsões Congelada Ativas e em Abertura",
          color: "primary-500",
          action: () => this.exportRelatorio("previsoes"),
        },
        {
          title: "Relatorio Empresas Carteira Faturas",
          description:
            "• Relatório de Empresas Divididas por carteira trazendo as ultimas 6 faturas",
          color: "primary-500",
          action: () => this.exportRelatorio("cliente-faturados"),
        },
        {
          title: "Empresas Comissões",
          description: "• Relatório de Comissõe Dos Vendedores",
          color: "primary-500",
          action: () => this.getUsers(),
        },
        {
          title: "Empresas Comissões dos que congelaram mas voltaram",
          description: "• Relatório de Comissõe Dos Vendedores",
          color: "primary-500",
          action: () => this.exportRelatorio("comissoes/excongelados"),
        },
        {
          title: "Relatório Financeiro Receita do Mes",
          description: "• Relatório Financeiro Valores de cada Tipo Cobrança",
          color: "primary-500",
          action: () => (this.deondevem = true),
        },
        {
          title: "Relatório Empresas Plano",
          description: "• Relatório de Empresas por Plano",
          color: "primary-500",
          action: () => this.exportPlano(),
        },
        {
          title: "Relatório Todas Empresas com Endereço",
          description: "• Relatório de Todas as Empresas com seus Endereços",
          color: "primary-500",
          action: () => this.gerarPadrao("empresas/relatorio/endereco"),
        },
        {
          title: "Relatório Todos Clientes com Endereço",
          description: "• Relatório de Todos os Clientes com seus Endereços",
          color: "primary-500",
          action: () => this.gerarPadrao("relatorio/clientes-endereco"),
        },
      ],
    };
  },
  computed: {
    filteredPlans() {
      let arrayNew = [];
      let data = this.plansArray.filter(({ type }) => type !== "pf");
      arrayNew.push({ id: 0, label: "todos" });
      for (let i = 0; i < data.length; i++) {
        arrayNew.push({ id: data[i].id, label: data[i].name });
      }
      return arrayNew;
    },
  },
  created() {
    this.fetchPlans();
  },
  methods: {
   async  getUsers() {
      await usersRequest().then(({ data: { data } }) => {
        let arrayNew = [];
        for (let i = 0; i < data.length; i++) {
          arrayNew.push({ id: data[i].id, label: data[i].nome_completo });
        }
        this.lista_usuarios = arrayNew;
      });
      this.comissao = true;
    },
    async congelados() {
      this.loading = true;
      await this.$store.dispatch("finanRelatorio/gerarRelatorioCongelados");
      this.loading = false;
    },
    async semAlvara() {
      this.loading = true;
      await this.$store.dispatch(
        "finanRelatorio/gerarRelatorioEmpresaSemAlvara"
      );
      this.loading = false;
    },
    async semContrato() {
      this.loading = true;
      await this.$store.dispatch(
        "finanRelatorio/gerarRelatorioEmpresaSemContrato"
      );
      this.loading = false;
    },
    async ClienteXFatura() {
      this.loading = true;
      await this.$store.dispatch("finanRelatorio/gerarRelatorioClienteXFatura");
      this.loading = false;
    },
    async ClienteXFaturaCartao() {
      this.loading = true;
      await this.$store.dispatch(
        "finanRelatorio/gerarRelatorioClienteXFaturaCartao"
      );
      this.loading = false;
    },
    async comissaoRelatorio() {
      this.loading = true;
      this.form.usuario = this.usuario ?? {};
      await this.$store.dispatch(
        "finanRelatorio/gerarRelatorioComissao",
        this.form
      );
      this.loading = false;
    },
    async deondevemRelatorio() {
      this.loading = true;
      window.open(
        `${process.env.VUE_APP_API_URL}/relatorio/financeiro/valores` +
        `?token=${this.$store.getters.getToken}&date=${formatBrToEn(
          this.form.data_competencia
        )}`,
        "_blank"
      );
      this.loading = false;
    },
    async canceladosRelatorio() {
      this.loading = true;
      window.open(
        `${process.env.VUE_APP_API_URL}/relatorio/cancelados` +
        `?token=${this.$store.getters.getToken}&data_inicial=${formatBrToEn(
          this.form.data_inicial
        )}&data_final=${formatBrToEn(this.form.data_final)}`,
        "_blank"
      );
      this.loading = false;
    },
    exportRelatorio(nome) {
      window.open(
        `${process.env.VUE_APP_API_URL}/relatorio/` +
        nome +
        `?token=${this.$store.getters.getToken}`,
        "_blank"
      );
    },
    fetchPlans() {
      this.loading = true;
      plansRequest()
        .then((response) => (this.plansArray = response.data.data))
        .catch((error) => this.$snack.error(error.response.data.message))
        .finally(() => (this.loading = false));
    },
    exportPlano() {
      const arraySerializado = JSON.stringify(this.plano_id);
      const url = `${process.env.VUE_APP_API_URL}/relatorio/relatorio-plano/?plano_id=${encodeURIComponent(
        arraySerializado
      )}&token=${this.$store.getters.getToken}`;
      window.open(url, "_blank");
    },
    async gerarPadrao(rota){
      this.loading = true;
      await this.$store.dispatch("finanRelatorio/gerarRelatorioPadrao",{rota:rota,data:{}});
      this.loading = false;
    }
  },
};
</script>

<style scoped></style>
